import { inject } from '@angular/core';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { PermissionService, TenantService } from '@hta/auth';
import { catchError, of, switchMap } from 'rxjs';

export const initialDataResolver = () => {
    const navigationService = inject(NavigationService);
    const tenantService     = inject(TenantService);
    const permissionService  = inject(PermissionService);

    // 1) Verificar sesión activa con el backend.
    //    getCurrentTenant() marca sessionEstablished=true si hay sesión válida,
    //    lo que evita que el cookieInterceptor recree la sesión innecesariamente.
    // 2) Cargar permisos ANTES de la navegación: navigation.api.ts filtra los
    //    módulos del sidebar por enabledModules(). Si los permisos no están
    //    cargados todavía, enabledModules() retorna [] y solo los items con
    //    moduleCode=null (Configuración) sobreviven.
    return tenantService.getCurrentTenant().pipe(
        catchError(() => of(null)),
        switchMap(() =>
            permissionService.loadPermissions().pipe(catchError(() => of(null)))
        ),
        switchMap(() => navigationService.get())
    );
};
